/**
 * Одна перезагрузка страницы на сессию вкладки, с защёлкой в sessionStorage.
 *
 * <p>Нужна там, где страница осталась со старой сборкой (протухший чанк, исчезнувшая серверная
 * функция): свежий бандл всё чинит, но повторять перезагрузку нельзя — если проблема не в бандле,
 * получится бесконечный цикл. Возвращает true, если перезагрузка запущена.
 */
export const reloadOnce = (key: string): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }

  try {
    if (sessionStorage.getItem(key) === 'true') {
      // Уже перезагружались и не помогло — снимаем защёлку, чтобы следующая
      // сессия вкладки снова имела право на одну попытку.
      sessionStorage.removeItem(key);
      return false;
    }
    sessionStorage.setItem(key, 'true');
  } catch {
    // sessionStorage недоступен (приватный режим, отключённые куки) — перезагружаем без защёлки:
    // без неё риск цикла, поэтому один раз и только если хранилище совсем не работает.
    return false;
  }

  window.location.reload();
  return true;
};
